module.exports = __webpack_public_path__ + "img/vps_security.34031ea.png";